import styled from "styled-components";

export const Tag = ({type = 'neutral', icon, text, ...restProps}) => {

    return (
        <StyledTag
            $hasText={text ? true : false}
            className={type === 'error' ? 'tagError' : type === 'warning' ? 'tagWarning' : type === 'success' ? 'tagSuccess' : 'tagNeutral'}
            {...restProps}
        >
            {icon}
            {text}
        </StyledTag>
    )
}

const StyledTag = styled.div`
    display: flex;
    width: fit-content;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    vertical-align: center;
    gap: ${({theme}) => theme.spacing.sm};
    border-radius: ${({theme}) => theme.cornerRadius.sm};
    font-size: ${({theme}) => theme.fontSize.sm};
    padding: ${({$hasText}) => $hasText ? '0 5px' : '0'};
    height: 20px;

    .icon
    {
        font-size: ${({theme}) => theme.iconSize.xs};
        color: ${({theme}) => theme.colors.mutedForeground};
    }

    &.tagNeutral
    {
        border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        color: ${({theme}) => theme.colors.mutedForeground};
        background: ${({theme}) => theme.colors.mutedBackground};
    }

    &.tagSuccess
    {
        color: ${({theme}) => theme.colors.successForeground};
        background: ${({theme}) => theme.colors.successBackground};

        .icon
        {
            color: ${({theme}) => theme.colors.successForeground};
        }
    }

    &.tagWarning
    {
        color: ${({theme}) => theme.colors.warningForeground};
        background: ${({theme}) => theme.colors.warningBackground};

        .icon
        {
            color: ${({theme}) => theme.colors.warningForeground};
        }
    }
    
    &.tagError
    {
        color: ${({theme}) => theme.colors.errorForeground};
        background: ${({theme}) => theme.colors.errorBackground};

        .icon
        {
            color: ${({theme}) => theme.colors.errorForeground};
        }
    }
    
`